import * as actionTypes from "../action-types";

const initialState = {
    customerDetails: null,
    milanSathiCustomerDetails: null,
    isLoginModalOpen: false,
    isSignupModalOpen: false,
    isForgetPasswordModalOpen: false,
};

const authReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.TOGGLE_LOGIN_MODAL:
            return { ...state, isLoginModalOpen: payload };

        case actionTypes.TOGGLE_SIGNUP_MODAL:
            return { ...state, isSignupModalOpen: payload };

        case actionTypes.TOGGLE_FORGET_PASSWORD_MODAL:
            return { ...state, isForgetPasswordModalOpen: payload };

        case actionTypes.SET_CUSTOMER_DETAILS:
            return { ...state, customerDetails: payload };

        case actionTypes.SET_MILAN_SATHI_CUSTOMER_DETAILS:
            return { ...state, milanSathiCustomerDetails: payload };

        default:
            return state;
    }
};

export default authReducer;